import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Container,
  Grid,
  Typography,
  Button,
  Modal,
  Fade,
  Backdrop,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CloseIcon from "@material-ui/icons/Close";

import SchoolImage from "../assets/images/SchoolImage.png";
import DemoVideoP1 from "../assets/images/DemoVideoP1.png";
import EverythingInOnePlace from "../assets/images/EverythingInOnePlace.png";
import ExcelParents1 from "../assets/images/ExcelParents1.png";
import DoubleBlueColorCircle from "../assets/images/DoubleBlueColorCircle.png";
import User1 from "../assets/images/User1.png";
import User2 from "../assets/images/User2.png";
import User3 from "../assets/images/User3.png";
import ParentsEngagement from "../assets/images/ParentsEngagement.png";
import CenterManagementP1 from "../assets/images/CenterManagementP1.png";
import ExcelParents2 from "../assets/images/ExcelParents2.png";
import youtube_home from "../assets/images/youtube_home.png";
import youtube_home_big from "../assets/images/youtube_home_big.png";
import image_with_logo from "../assets/images/image_with_logo.svg";

import green_checked_icon from "../assets/images/green_checked_icon.svg";

import SliderImage from "../components/SliderImage";
import SliderImage2 from "../components/SliderImage2";
import { Transform } from "@material-ui/icons";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import MySlickSlider from "../components/MySlickSlider";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "40px 30px",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      padding: 10,
    },
  },
  wrapper2: {
    padding: "0px 100px",
    [theme.breakpoints.down("xs")]: {
      padding: 10,
    },
  },
  wrapper3: {
    marginTop: 80,
    marginBottom: 30,
    padding: "40px 100px 60px 100px",
    background: "#E3EBFC",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
      marginTop: 40,
    },
    [theme.breakpoints.down("xs")]: {
      padding: 20,
      marginTop: 40,
    },
  },
  wrapper4: {
    padding: "45px 150px 60px 150px",
    [theme.breakpoints.down("md")]: {
      padding: "45px 110px 60px 110px",
    },
    [theme.breakpoints.down("xs")]: {
      padding: 10,
    },
  },
  wrapper5: {
    // padding: "45px 60px 60px 60px",
    padding: "45px 47px 60px 47px",

    position: "relative",
    // background: "#ddd",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
    },
  },
  wrapper5_outer: {
    width: "83%",
    [theme.breakpoints.down("md")]: {
      width: "93%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "90%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "85%",
    },
  },
  box: {
    boxShadow: "1px 1px 3px 2px #ddd",
    borderRadius: 7,
    padding: "20px 50px",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
    },
  },
  center: {
    textAlign: "center !important",
  },
  banner_button: {
    padding: "13px 35px  !important",
    [theme.breakpoints.down("sm")]: {
      padding: "7px 16px  !important",
    },
    [theme.breakpoints.down("xs")]: {
      marginBottom: 10,
    },
  },

  margin_left_20: {
    marginLeft: 20,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 3,
    },
  },
  big_title: {
    fontSize: "2.5rem",
    fontWeight: 700,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.25rem",
    },
  },
  title: {
    fontSize: "2.5rem",
    fontWeight: 600,
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.75rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.25rem",
    },
  },
  h5: {
    padding: "10px 10px 25px 10px",
    width: "70%",
    margin: "auto",
    fontWeight: 400,
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  title2: {
    fontSize: "1.6rem",
    fontWeight: 600,
    marginBottom: 10,
    [theme.breakpoints.down("md")]: {
      fontSize: "1.4rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.1rem",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "1rem",
    },
  },
  image: {
    maxWidth: "100%",
  },
  h6: {
    margin: "20px 0px",
    textAlign: "left",
  },
  demo_top: {
    margin: "0px 0px",
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
  margin30: {
    margin: "60px 0px",
    [theme.breakpoints.down("sm")]: {
      margin: "15px 0px",
    },
  },
  h4: {
    textAlign: "left",
    paddingBottom: 0,
  },
  subtitle1: {},
  flex_center: {
    display: "flex",
    alignItems: "center",
    padding: "30px 60px",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
    },
  },
  image_center: {
    display: "flex",
    justifyContent: "center",
  },
  box2: {
    textAlign: "center",
    boxShadow: "1px 1px 3px 1px #ddd",
    borderRadius: 12,
    padding: "20px 20px 90px 20px",
    margin: 3,
    height: "100%",
    position: "relative",
  },

  box2_icon: {
    margin: 12,
    width: "50px",
  },
  linkStyle: {
    textDecoration: "underline",
    color: "#EE6741",
    fontSize: "14px",
    fontFamily: "Open Sans,sans-serif",
    fontWeight: 600,

    position: "absolute",
    bottom: 45,
    left: "50%",
    transform: "translate(-50%,0)",
  },
  link: {
    textDecoration: "underline",
    fontWeight: 600,
    margin: 20,
    color: "#EE6741",
  },
  link2: {
    fontWeight: 600,
    margin: "10px 10px 10px 0px",
  },
  link2_icon: {
    position: "relative",
    top: 7,
    fontSize: "1.5rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1.125rem",
    },
  },
  flex_center2: {
    display: "flex",
    alignItems: "center",
    padding: "20px 60px",
    [theme.breakpoints.down("xs")]: {
      padding: 20,
    },
  },
  padding_bottom: {
    paddingBottom: 20,
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 0,
    },
  },
  title_bg: {
    background: `url(${DoubleBlueColorCircle})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "20% 50%",
    backgroundSize: "9%",
    [theme.breakpoints.down("xs")]: {
      backgroundPosition: "4% 50%",
    },
  },
  title_bg2: {
    background: `url(${DoubleBlueColorCircle})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "40% 50%",
    backgroundSize: "5%",
    [theme.breakpoints.down("xs")]: {
      paddingTop: 60,
    },
  },
  box3: {
    background: "#fff",
    boxShadow: "1px 1px 3px 1px #ddd",
    borderRadius: 12,
    padding: "65px 20px 50px 20px",
    marginTop: 35,
    position: "relative",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      padding: "45px 20px 30px 20px",
    },
    // [theme.breakpoints.down("sm")]: {
    //   marginBottom: 35,
    // },
  },
  linkStyle3: {
    textDecoration: "underline",
    fontSize: "14px",
    fontFamily: "Open Sans,sans-serif",
    fontWeight: 600,
    position: "absolute",
    bottom: 42,
    [theme.breakpoints.down("md")]: {
      fontSize: "12px",
      bottom: 30,
    },
  },
  box3_icon: {
    width: "110px",
    position: "absolute",
    left: "calc(50% - 55px)",
    top: -50,
    [theme.breakpoints.down("md")]: {
      width: "80px",
      left: "calc(50% - 40px)",
    },
  },
  bg_color: {
    background: "#E3EBFC",
    height: "300px",
    width: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    zIndex: -9,
    borderRadius: 15,
  },
  // left: {
  //   textAlign: "left",
  // },
  userCardTitle: {
    textAlign: "left",
    [theme.breakpoints.down("md")]: {
      // minHeight: "60px",
      fontSize: "0.875rem",
    },
    [theme.breakpoints.down("sm")]: {
      // minHeight: "60px",
      fontSize: "1rem",
    },
  },
  wrapper5_inner: {
    padding: 60,
    background: "#E3EBFC",
    borderRadius: 15,
    [theme.breakpoints.down("xs")]: {
      padding: 15,
    },
  },
  icon_style: {
    position: "relative",
    top: "7px",
    left: "4px",
  },
  tab_headline3: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#F26522",
    marginBottom: "40px",
    marginTop: "15px",
    textAlign: "center",
  },
  tab_headline3_M: {
    fontWeight: 600,
    fontSize: "18px",
    color: "#F26522",
    marginTop: "15px",
    textAlign: "center",
  },

  slider_text2_M: {
    padding: "0px 10px",
    [theme.breakpoints.down("xs")]: {
      padding: "0px 10px 20px 10px",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  youtube_paper: {
    border: "20px solid #000",
  },
  hide_br: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  marginBottomStyle: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "30px",
    },
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      display: "block",
      margin: "30px auto",
    },
  },
  demoStyle: {
    margin: "12px 0px",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
      display: "block",
      margin: "15px auto",
    },
  },
}));

const Home = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* <CssBaseline /> */}
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper}>
          <Grid item lg={12} md={12}>
            <Typography className={classes.big_title}>
              Easiest & holistic solution
              <br />
              for your childcare
            </Typography>
            <Typography variant="h5" className={classes.h5}>
              Focused on reimagining childcare by connecting children, parents,
              and daycares alike with everything you need in one convenient
              dashboard.
            </Typography>
            <div className={classes.center}>
              <Link to="/try-it-free">
                <Button
                  variant="contained"
                  color="primary"
                  className={`${classes.banner_button} button`}
                >
                  Try it Free
                </Button>
              </Link>
              <Link to="/emergency">
                <Button
                  variant="outlined"
                  // color="secondary"
                  className={`${classes.banner_button} ${classes.margin_left_20} button`}
                >
                  Emergency (911)
                </Button>
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container className={classes.wrapper2}>
          <Grid lg={12} md={12}>
            <Grid container spacing={3} className={classes.box}>
              <Grid item lg={6} md={6}>
                <Typography className={classes.title2}>
                  Join childcare system <br />
                  used by 1000+ organaisation
                </Typography>
                <Typography variant="subtitle1">
                  KinderCubby has been used by over 1000+ daycare centers across
                  the country. For professionals looking to elevate their
                  childcare business to a new level, book a call with our team
                  today to discuss how we can best serve your needs.
                </Typography>
                <Link to="/request-call">
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ marginTop: 15 }}
                    className={`${classes.banner_button} button`}
                  >
                    Contact Sales
                  </Button>
                </Link>
              </Grid>
              <Grid item lg={6} md={6}>
                <img src={image_with_logo} alt="" className={classes.image} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} className={classes.wrapper3}>
          <Grid lg={12} md={12} sm={12} xs={12}>
            <Typography className={classes.title} style={{ textAlign: "left" }}>
              Why KinderCubby?
            </Typography>
          </Grid>
          <Grid lg={8} md={8} sm={12} xs={12}>
            <Grid container spacing={3}>
              <Grid item lg={6} md={6}>
                <Typography variant="h6" className={classes.h6}>
                  Effortless
                  <br className={classes.hide_br} /> Attendance
                </Typography>
                <Typography variant="body1">
                  Automatically record and submit attendance records with ease.
                  No more name calling or written material is needed.
                </Typography>
              </Grid>
              <Grid item lg={6} md={6}>
                <Typography variant="h6" className={classes.h6}>
                  Save time with
                  <br className={classes.hide_br} /> Activity tracking
                </Typography>
                <Typography variant="body1">
                  Track activities with ease by monitoring duration and
                  effectiveness.
                </Typography>
              </Grid>
              <Grid item lg={6} md={6}>
                <Typography variant="h6" className={classes.h6}>
                  Digital report go
                  <br className={classes.hide_br} /> paperless
                </Typography>
                <Typography variant="body1">
                  Access an all-in-one dashboard with everything your childcare
                  center needs with just a few clicks.
                </Typography>
              </Grid>
              <Grid item lg={6} md={6}>
                <Typography variant="h6" className={classes.h6}>
                  Boost Organisation
                  <br className={classes.hide_br} /> growth
                </Typography>
                <Typography variant="body1">
                  Increase revenue and increase classroom size to make your
                  childcare center known.
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid lg={4} md={4} sm={12} xs={12}>
            <Typography variant="h6" className={classes.demo_top}>
              SEE IN ACTION
            </Typography>
            <img
              src={youtube_home}
              className={`${classes.image} ${classes.demoStyle}`}
              alt=""
            />
            <div className={classes.center}>
              <Button
                variant="contained"
                color="primary"
                className={`${classes.banner_button} button`}
                onClick={handleOpen}
              >
                Watch The Demo
              </Button>

              <Modal
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <span style={{ position: "relative" }}>
                    <CloseIcon
                      style={{
                        position: "absolute",
                        right: -40,
                        top: -5,
                        fontSize: "2rem",
                      }}
                      onClick={handleClose}
                    />
                    <img
                      src={youtube_home_big}
                      alt=""
                      className={classes.youtube_paper}
                    />
                  </span>
                </Fade>
              </Modal>
            </div>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid container className={classes.wrapper4}>
          <Grid lg={12} md={12} sm={12} xs={12}>
            <Typography className={classes.title}>
              Progressive childcare solution <br /> for growing world
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.flex_center}>
            <Grid lg={6} md={6} className={classes.margin30}>
              <Typography variant="h4" className={classes.h4}>
                Everything in one place
              </Typography>
              <Typography variant="h6" className={classes.h6}>
                With an intuitive dashboard, you can access attendance records,
                activities, contact information, and manage your center with
                ease.
              </Typography>
            </Grid>
            <Grid
              lg={6}
              md={6}
              sm={12}
              xs={12}
              className={classes.image_center}
            >
              <img
                src={EverythingInOnePlace}
                className={`${classes.image} ${classes.marginBottomStyle}`}
                alt=""
              />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item lg={4} md={4}>
              <div className={classes.box2}>
                <img
                  src={green_checked_icon}
                  alt=""
                  className={classes.box2_icon}
                />
                <Typography variant="h5">Activity Tracking</Typography>
                <Typography variant="subtitle1" className={classes.subtitle1}>
                  Keep a running list of childcare activities, outcomes, and
                  other notes to ensure children are maximizing their engagement
                  ability.
                </Typography>

                <Link to="/activity-tracking" className={classes.linkStyle}>
                  Learn More
                </Link>
              </div>
            </Grid>
            <Grid item lg={4} md={4}>
              <div className={classes.box2}>
                <img
                  src={ParentsEngagement}
                  alt=""
                  className={classes.box2_icon}
                />
                <Typography variant="h5">Parent engagement</Typography>
                <Typography variant="subtitle1" className={classes.subtitle1}>
                  Notify and keep in touch with parents seamlessly by contacting
                  and updating them electronically.
                </Typography>

                <Link to="/parents-engagements" className={classes.linkStyle}>
                  Learn More
                </Link>
              </div>
            </Grid>
            <Grid item lg={4} md={4}>
              <div className={classes.box2}>
                <img
                  src={CenterManagementP1}
                  alt=""
                  className={classes.box2_icon}
                  style={{
                    background: "#8BA0C9",
                    height: "50px",
                    width: "50px",
                    borderRadius: 50,
                    padding: 10,
                  }}
                />
                <Typography variant="h5">Center Management</Typography>
                <Typography variant="subtitle1" className={classes.subtitle1}>
                  Manage your daycare center’s staff, clients, and business with
                  an all inclusive dashboard that provides you with everything
                  you need to succeed.
                </Typography>

                <Link to="/center-management" className={classes.linkStyle}>
                  Learn More
                </Link>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} className={classes.wrapper3}>
          <Grid lg={12} md={12}>
            <Typography className={classes.title}>
              Manage the function you already do <br /> but much more seamlessly
            </Typography>
            <Typography variant="h5" className={classes.h5}>
              Manage children and parents with a custom, online presence. There
              is no need for endless paperwork and fild folders anymore.
            </Typography>
            <div>
              <MySlickSlider />
              {/* <SliderImage2 /> */}
            </div>
            <Link to="/feature-overviews">
              <Typography
                className={`${classes.tab_headline3_M} ${classes.slider_text2_M}`}
              >
                See All Features{" "}
                <span className={classes.icon_style}>
                  <ArrowForwardIcon />
                </span>
              </Typography>
            </Link>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg">
        <Grid container className={classes.wrapper4}>
          <Grid lg={12} md={12} sm={12} xs={12}>
            <Typography
              className={`${classes.title} ${classes.padding_bottom} ${classes.title_bg}`}
            >
              Excel Parents expectation
            </Typography>
          </Grid>
          <Grid container spacing={3} className={classes.flex_center2}>
            <Grid lg={6} md={6}>
              <Typography variant="h6" className={classes.h6}>
                Update parents with how their children are doing. Send
                reminders, notifications, and provide with outcomes their child
                has achieved at your childcare center.
              </Typography>
            </Grid>
            <Grid lg={6} md={6} className={classes.image_center}>
              <img
                src={ExcelParents2}
                className={`${classes.image} ${classes.marginBottomStyle}`}
                alt=""
              />
            </Grid>
          </Grid>
        </Grid>
      </Container>

      <Container maxWidth="lg" className={classes.wrapper5_outer}>
        <Grid container spacing={matches ? 8 : 4} className={classes.wrapper5}>
          <Grid lg={12} md={12} sm={12} xs={12}>
            <div className={classes.bg_color}></div>
            <Typography
              className={`${classes.title} ${classes.padding_bottom}`}
            >
              KinderCubby Users
            </Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className={classes.box3}>
              <img
                src={User1}
                alt=""
                className={classes.box3_icon}
                style={{ background: "#fff", borderRadius: 50 }}
              />
              <Typography variant="h5" className={classes.userCardTitle}>
                Daycare Owners & Directors
              </Typography>
              <Typography variant="subtitle1" className={classes.subtitle1}>
                Designed to help daycare managers control their business easily.
              </Typography>
              <Link
                to="/for-owners-and-directors"
                className={classes.linkStyle3}
              >
                {/* <Typography variant="body2" className={classes.link2}> */}
                Learn More <ArrowForwardIcon className={classes.link2_icon} />
                {/* </Typography> */}
              </Link>
            </div>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className={classes.box3}>
              <img src={User2} alt="" className={classes.box3_icon} />
              <Typography variant="h5" className={classes.userCardTitle}>
                Teachers
              </Typography>
              <Typography variant="subtitle1" className={classes.subtitle1}>
                Assists teachers with attendance, activities, and tracking child
                outcomes.
              </Typography>
              <Link to="/for-teachers" className={classes.linkStyle3}>
                {/* <Typography variant="body2" className={classes.link2}> */}
                Learn More <ArrowForwardIcon className={classes.link2_icon} />
                {/* </Typography> */}
              </Link>
            </div>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <div className={classes.box3}>
              <img src={User3} alt="" className={classes.box3_icon} />
              <Typography variant="h5" className={classes.userCardTitle}>
                Parents
              </Typography>
              <Typography variant="subtitle1" className={classes.subtitle1}>
                Allows a new way for parents to participate in childcare.
              </Typography>
              <Link to="/for-parents" className={classes.linkStyle3}>
                {/* <Typography variant="body2" className={classes.link2}> */}
                Learn More <ArrowForwardIcon className={classes.link2_icon} />
                {/* </Typography> */}
              </Link>
            </div>
          </Grid>
        </Grid>
      </Container>

      <div className={classes.slider}>
        <Typography className={`${classes.title} ${classes.title_bg2}`}>
          Factual Impact
        </Typography>
        <SliderImage
          msg={
            "Amazing! We love KinderCubby because it has a number of functions that makes it easy for our business managers, teachers, and even parents to collaborate with each other"
          }
        />
        <Link to="/case-studies">
          <Typography
            className={`${classes.tab_headline3} ${classes.slider_text2_M}`}
          >
            More Customer Stories{" "}
            <span className={classes.icon_style}>
              <ArrowForwardIcon />
            </span>
          </Typography>
        </Link>
      </div>

      <Container maxWidth="lg">
        <Grid container spacing={4} className={classes.wrapper5}>
          <Grid lg={12} md={12} sm={12} xs={12}>
            <div className={classes.wrapper5_inner}>
              <Typography className={`${classes.title}`}>
                KinderCubby made it easy. Why wait?
              </Typography>
              <Typography
                variant="h6"
                className={`${classes.h6} ${classes.center}`}
              >
                Get connected with our support team to schedule a demo, try it
                for free, and secure a subscription to take your daycare center
                to the next level.
              </Typography>
              <div className={classes.center}>
                <Link to="/try-it-free">
                  <Button
                    variant="contained"
                    color="primary"
                    className={`${classes.banner_button} button`}
                  >
                    Try it Free
                  </Button>
                </Link>
                <Link to="/pricing">
                  <Button
                    variant="outlined"
                    color="secondary"
                    className={`${classes.banner_button} ${classes.margin_left_20} button`}
                  >
                    Explore Pricing
                  </Button>
                </Link>
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Home;
